var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5247 3.49531C13.7841 3.49531 14 3.71065 14 3.98464V4.23797C14 4.5053 13.7841 4.7273 13.5247 4.7273H2.4759C2.21591 4.7273 2 4.5053 2 4.23797V3.98464C2 3.71065 2.21591 3.49531 2.4759 3.49531H4.41971C4.81457 3.49531 5.1582 3.21465 5.24703 2.81865L5.34882 2.36399C5.50702 1.74467 6.02766 1.33334 6.62351 1.33334H9.37649C9.96585 1.33334 10.4923 1.74467 10.6447 2.33133L10.7536 2.81799C10.8418 3.21465 11.1854 3.49531 11.5809 3.49531H13.5247ZM12.5372 12.756C12.7402 10.8647 13.0955 6.37142 13.0955 6.32609C13.1084 6.18875 13.0637 6.05876 12.9749 5.95409C12.8796 5.85609 12.759 5.79809 12.626 5.79809H3.37901C3.24545 5.79809 3.11837 5.85609 3.03019 5.95409C2.94072 6.05876 2.89663 6.18875 2.90311 6.32609C2.9043 6.33442 2.91705 6.49269 2.93837 6.75731C3.03306 7.93281 3.29678 11.2068 3.46719 12.756C3.58779 13.8973 4.33665 14.6147 5.42137 14.6407C6.25842 14.66 7.12075 14.6667 8.00253 14.6667C8.83309 14.6667 9.67662 14.66 10.5396 14.6407C11.6619 14.6213 12.4101 13.9167 12.5372 12.756Z",
    fill: "#EB5757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5823eb8618b146763cadb6d32f14cade.svg";
export { ForwardRef as ReactComponent };